import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { lbToKG } from "Helpers/util";
import React, { useEffect, useState, useRef, memo, useCallback } from "react";
import CheckboxButton from "Root/quiz/elements/checkboxElement/checkbox.element";
import QuestionHeader from "Root/quiz/elements/questionHeader/questionHeader";
import RadioButton from "Root/quiz/elements/radioButton/radio";
import SliderComponent from "Root/quiz/elements/sliderComponent/slider";
import PopUp from "Root/quiz/elements/PopUpElement/popUp";
import BottomCross from "Root/quiz/elements/bottomCross/bottomCross";
import HelpText from "Root/quiz/elements/helpText/helpText";
import { getHintText, getIsInterstitial } from "Root/quiz/helpers/questionHelper";
import CredInput from "Root/quiz/elements/credInput/credInput";
import { CSSTransition } from "react-transition-group";
import questionTypes from "Root/quiz/data/constants/questionTypes";
import isOptionsTooLong from "Root/quiz/helpers/getButtonStyle/getButtonStyle";
import { apiGetHelpText } from "Root/api/apiQuiz";
import ProductCheckbox from "Root/quiz/elements/productCheckbox";
import RegFont from "Root/profile/components/common/RegFont";
import TargetInterstitial from "Root/quiz/elements/targetInterstitial";
import ResultsAnimation from "Root/quiz/elements/resultsAnimation";
import TargetAnimation from "Root/quiz/elements/targetAnimation";
import TargetPurchaseSelect from "Root/quiz/elements/targetPurchaseSelect";
import styles from "./styles.module.scss";
import HeightAndWeightComponent from "../hardcoded/heightAndWeight/heightAndWeight";
import GoalWeight from "../hardcoded/goalWeight/goalWeight";
import RDQuestion from "../hardcoded/RDQuestion/rDQuestion";
import RDInterstitial from "../RDinterstitial";
import Interstitial from "../interstitial";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import VideoQuestion from "Root/quiz/elements/videoQuestion";
import cx from "classnames";
const validAgeVals = ["18-24", "25-34", "35-44", "45-54", "55+"];
const QuizContent = (props) => {
    const { question, autoNext, goNext } = props;
    const [isOpen, setOpen] = useState(false);
    const [headerRef, setHeaderRef] = useState();
    const [helpText, setHelpText] = useState();
    const [deselectFlag, setDeselectFlag] = useState(false);
    const screnWidth = useScreenWidth();
    const mainComponent = useRef(null);
    const isHyrox = location.href.includes("hyrox");
    const getHelpText = async () => {
        if (question.helpText && question.helpText.length > 0) {
            setHelpText(question.helpText);
            return;
        }
        if (typeof question.options !== "undefined") {
            if (question.questionName === "age_bucket" &&
                props.value !== null &&
                props.value.length > 0 &&
                validAgeVals.indexOf(props.value.join()) >= 0) {
                const help_text = await apiGetHelpText({
                    gender: props.quizAnswers.gender,
                    age: props.value.join(),
                });
                setHelpText(help_text);
                return;
            }
            const optionsHelpText = question.options.find((elem) => props.value.includes(elem.value))?.helpText;
            if (optionsHelpText) {
                setHelpText(optionsHelpText);
                return;
            }
        }
        else if (question.questionName === "goalWeight" && props.value && typeof props.value === "object") {
            const getCopy = (string) => `We see you’d like to ${string}. Your Registered Dietitian will be an important part of the process to help you design a complete nutrition regimen that will work toward achieving that goal.`;
            const goalWeight = Number(props.value.join());
            const goalWeightKg = lbToKG(goalWeight);
            const weight = props.quizAnswers.heightAndWeight && props.quizAnswers.heightAndWeight.split(",")[0];
            const weightKg = lbToKG(weight);
            if (goalWeight) {
                let help_Text = "";
                if (Number(weight) === goalWeight) {
                    help_Text = getCopy("maintain your weight");
                    setHelpText(helpText);
                }
                else if (goalWeight > Number(weight)) {
                    help_Text = props.metrics
                        ? getCopy(`gain ${goalWeightKg - weightKg} kilograms`)
                        : getCopy(`gain ${goalWeight - Number(weight)} pounds`);
                }
                else if (goalWeight < Number(weight)) {
                    help_Text = props.metrics
                        ? getCopy(`lose ${weightKg - goalWeightKg} kilograms`)
                        : getCopy(`lose ${Number(weight) - goalWeight} pounds`);
                }
                setHelpText(help_Text);
                return;
            }
        }
        setHelpText(undefined);
    };
    const checkIfSelectedValueIsDeselectOther = (value) => {
        // Checks if the value selected is a "deselect others" value
        if (Array.isArray(value)) {
            if (value.length === 1) {
                const value_str = value[0];
                question.options.forEach((option) => {
                    if (option.value === value_str) {
                        if (option.deselectOthers) {
                            setDeselectFlag(true);
                        }
                    }
                });
            }
        }
    };
    useEffect(() => {
        getHelpText();
        if (question.questionType === "checkbox") {
            checkIfSelectedValueIsDeselectOther(props.value);
        }
    }, [props.value, props.questionName, props.metrics]);
    const setSingleString = (e) => {
        props.setValue(() => [e]);
    };
    const getButtonStyles = () => {
        if (typeof question.options !== "undefined") {
            const type = question.questionType;
            if (type !== questionTypes.radio || type !== questionTypes.checkbox) {
                return isOptionsTooLong(question.options.map((opt) => opt.text), screnWidth < 721 ? 16 : 30)
                    ? styles.columns
                    : styles.rows;
            }
        }
        return "";
    };
    const updateFreeFormField = (string) => {
        props.setFreeFormValue((prevState) => ({ ...prevState, [question.questionName]: string }));
    };
    const UIElement = useCallback(() => {
        switch (question.questionType) {
            case "radio":
                return (_jsx(_Fragment, { children: question.options.map((option, i) => (_jsx(RadioButton, { value: option.value, checked: props.value, setValue: setSingleString, text: option.text, iconRaw: option.iconRaw, isFreeForm: option.free_form, setFreeFormValue: updateFreeFormField, freeFormValue: props.freeFormValue, autoNext: autoNext, goNext: goNext }, option.value + i.toString()))) }));
            case "slider":
                return _jsx(SliderComponent, { options: question.options, setValue: props.setValue, answer: props.value });
            case "checkbox":
                return question.options.map((option, i) => (_jsx(CheckboxButton, { value: option.value, text: option.text, setValue: props.setValue, answers: props.value, deselect: option.deselect, iconRaw: option.iconRaw, stopper: props.question.maxOptions, deselectOtherFlag: deselectFlag, setFlag: setDeselectFlag, deselectOther: option.deselectOthers, isFreeForm: option.free_form, setFreeFormValue: updateFreeFormField, freeFormValue: props.freeFormValue, autoNext: autoNext, goNext: goNext }, option.value + i.toString())));
            case "text_area":
                return _jsx(RDQuestion, { setValue: props.setValue, value: props.value });
            case "hardcode":
                if (question.questionName === "heightAndWeight") {
                    return (_jsx(HeightAndWeightComponent, { setValue: props.setValue, prevAnswer: question.userAnswer, metrics: props.metrics, setMetrics: props.setMetrics }));
                }
                if (question.questionName === "goalWeight") {
                    return (_jsx(GoalWeight, { setValue: props.setValue, prevAnswer: question.userAnswer, metrics: props.metrics, setMetrics: props.setMetrics }));
                }
                if (question.questionName === "targetPurchase") {
                    return _jsx(TargetPurchaseSelect, { value: props.value, setValue: props.setValue });
                }
                break;
            case "text": {
                let inputNumber = 0;
                props.setValue(Array(2));
                return question.options.map((option) => (_jsx(CredInput, { num: inputNumber++, type: option.type, label: option.text, isOptional: !!option.isOptional, setValue: props.setValue, defaultValue: option.value })));
            }
            // below added for testing
            case "rd_interstitial": {
                const name = "Mary Albus";
                const body2 = "Take this 5-minute quiz so I can design a nutrition system that works specifically for your physiology, dietary needs, and goals.";
                return _jsx(RDInterstitial, { goNext: props.goNext, name: name, body2: body2 });
            }
            case "interstitial": {
                return _jsx(Interstitial, { text: question.text, img: question.image_url });
            }
            case "target_interstitial": {
                return _jsx(TargetInterstitial, { text: question.text, goNext: props.goNext, img: question.image_url });
            }
            case "results_animation": {
                return _jsx(ResultsAnimation, { text: question.text, goNext: props.goNext });
            }
            case "target_animation": {
                return _jsx(TargetAnimation, { goNext: props.goNext });
            }
            case "product_checkbox": {
                let colNum = question.options.length < 4 ? question.options.length : 4;
                return (_jsxs("div", { className: styles.product_checkbox_wrapper, children: [props.question.maxOptions !== 1 && (_jsx("div", { className: styles.product_checkbox_title, children: _jsx(RegFont, { children: "Select all that apply" }) })), _jsx("div", { className: styles.product_checkbox, style: {
                                gridTemplateColumns: `repeat(${colNum}, 1fr)`,
                            }, children: question.options.map((option, i) => option.value.toLowerCase() !== "none" ? (_jsx(ProductCheckbox, { value: option.value, text: option.text, setValue: props.setValue, answers: props.value, deselect: option.deselect, stopper: props.question.maxOptions, deselectOtherFlag: deselectFlag, setFlag: setDeselectFlag, deselectOther: option.deselectOthers, imgSrc: option.iconPath, variant: question.options.length < 4 ? "tall" : undefined, autoNext: autoNext, goNext: goNext }, option.value + i.toString())) : (_jsx(CheckboxButton, { value: option.value, text: option.text, setValue: props.setValue, answers: props.value, deselect: option.deselect, iconRaw: option.iconRaw, stopper: props.question.maxOptions, deselectOtherFlag: deselectFlag, setFlag: setDeselectFlag, deselectOther: option.deselectOthers, isFreeForm: option.free_form, setFreeFormValue: updateFreeFormField, freeFormValue: props.freeFormValue, className: styles.none_checkbox, autoNext: autoNext, goNext: goNext }, option.value + i.toString()))) })] }));
            }
            case "video": {
                return _jsx(VideoQuestion, { video: question.image_url, text: question.text });
            }
            default:
                return _jsx(_Fragment, {});
        }
        return _jsx(_Fragment, {});
    }, [question, setDeselectFlag, setSingleString]);
    return (_jsx("div", { className: cx({
            [styles.quiz_wrapper_noButtonBar]: props.quizContentNoButtonBar,
            [styles.quiz_wrapper]: !props.quizContentNoButtonBar,
            [styles.hyrox]: isHyrox,
        }), 
        // className={[props.quizContentNoButtonBar ? styles.quiz_wrapper_noButtonBar : styles.quiz_wrapper].join(" ")}
        ref: mainComponent, children: getIsInterstitial(question?.questionType) ? (UIElement()) : (_jsx("div", { id: "quiz-container", className: styles.quiz_container, children: _jsxs("div", { className: styles.question_container, children: [_jsx(QuestionHeader, { setRef: setHeaderRef, isOpen: (e) => setOpen(e), whytitle: question.whyWeAskTitle, header: question.title, whytext: question.whyWeAsk, show: props.show, isHyrox: isHyrox }), _jsx(CSSTransition, { in: props.show, timeout: isHyrox ? 0 : 200, classNames: isHyrox
                            ? {
                                enterDone: styles.MyClassEnterDone,
                            }
                            : {
                                enterActive: styles.MyClassEnterActive,
                                enterDone: styles.MyClassEnterDone,
                                exitActive: styles.MyClassExit,
                                exitDone: styles.MyClassExitActive,
                            }, children: _jsxs("div", { className: styles.question_content_container, children: [getHintText(question.questionType, question.maxOptions) && (_jsx("span", { className: styles.hint, children: getHintText(question.questionType, question.maxOptions) })), _jsx("div", { className: getButtonStyles(), children: UIElement() }), question.image_url && question.questionName === "hyrox_athlete_spectator" ? (_jsx("div", { className: styles.hyroxImageWrapper, children: _jsx("img", { className: styles.hyroxImage, src: question.image_url, alt: "" }) })) : null, question.whyWeAsk && headerRef && (_jsxs(PopUp, { text: question.whyWeAskTitle ? question.whyWeAskTitle.toUpperCase() : "Why we ask".toUpperCase(), open: isOpen, close: () => setOpen(false), children: [_jsx("span", { className: styles.whyWeAskCopy, children: question.whyWeAsk }), _jsx(BottomCross, { setOpen: () => setOpen(false) })] })), helpText && (_jsx("div", { className: styles.helptext, children: _jsx(HelpText, { helpText: helpText }) }))] }) })] }) })) }, question.title));
};
export default memo(QuizContent);
